import styled from 'styled-components';
import { Grid } from 'react-flexbox-grid';

const SeparatorWrapper = styled(Grid)`
  margin: 1.5em 0;
`;

export { SeparatorWrapper };
